import { render, staticRenderFns } from "./LenderFees.vue?vue&type=template&id=c6ef7ad8&scoped=true"
import script from "./LenderFees.vue?vue&type=script&lang=js"
export * from "./LenderFees.vue?vue&type=script&lang=js"
import style0 from "./LenderFees.vue?vue&type=style&index=0&id=c6ef7ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ef7ad8",
  null
  
)

export default component.exports